// Imports
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      meta: {
        title: 'Puntos de pago',
      },
      component: () => import('@/components/GoogleMap.vue'),
      children: [
        {
          path: '/home',
          name: 'MSM application',
          component: () => import('@/components/GoogleMap.vue'),
        },
      ],
    },

  ],
})

export default router
